webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bulmaComponentGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(5);


var plugin = {};

var nameHtmlElement = new Map([['input', 'b-input'], ['label', 'b-label'], ['image', 'b-image'], ['form', 'b-form'], ['button', 'b-button'], ['content', 'b-content'], ['progress', 'b-progress'], ['table', 'b-table'], ['title', 'b-title'], ['menu', 'b-menu']]);

plugin.install = function (Vue, option) {
  __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].forEach(function (name) {
    Vue.component('' + (option && option.prefix || '') + (nameHtmlElement.get(name) || name), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components__["b" /* componentGenerator */])(name));
  });
};

/* harmony default export */ __webpack_exports__["a"] = (plugin);
var bulmaComponentGenerator = __WEBPACK_IMPORTED_MODULE_0__components__["b" /* componentGenerator */];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(18),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugin_plugin__ = __webpack_require__(1);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2__plugin_plugin__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return componentGenerator; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function camelCaseToDash(myStr) {
  return myStr.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase().replace(/([a-z])([0-9])/g, '$1-$2');
}

var outerElementsMap = new Map([['input', 'input'], ['label', 'label'], ['button', 'button'], ['image', 'figure'], ['form', 'form']]);

var componentGenerator = function componentGenerator(name, reqOuterElement) {
  return {
    name: name,
    functional: true,
    render: function render(h, _ref) {
      var children = _ref.children,
          props = _ref.props,
          data = _ref.data;

      var outerElement = props.outerElement,
          otherProps = _objectWithoutProperties(props, ['outerElement']);

      return h(outerElement || reqOuterElement || outerElementsMap.get(name) || 'div', _extends({
        class: [camelCaseToDash(name)].concat(_toConsumableArray(Object.keys(otherProps).filter(function (key) {
          return otherProps[key] !== false;
        }).map(function (str) {
          return camelCaseToDash(str);
        }).filter(function (key) {
          return key.substring(0, 3) === 'is-' || key.substring(0, 4) === 'has-';
        })))
      }, data), children);
    }
  };
};


/* harmony default export */ __webpack_exports__["a"] = (['columns', 'column', 'notification', 'button', 'box', 'icon', 'media', 'media-left', 'media-right', 'media-content', 'image', 'content', 'level', 'level-left', 'level-item', 'level-right', 'field', 'help', 'progress', 'table', 'tag', 'title', 'subtitle', 'breadcrumb', 'card', 'card-image', 'card-content', 'card-footer', 'card-footer-item', 'control', 'label', 'menu', 'menu-label', 'menu-list', 'message', 'message-header', 'message-body', 'modal', 'modal-background', 'modal-content', 'modal-close', 'navbar', 'navbar-item', 'navbar-brand', 'navbar-burger', 'navbar-start', 'navbar-link', 'navbar-dropdown', 'navbar-divider', 'pagination', 'pagination-previous', 'pagination-next', 'pagination-list', 'pagination-ellipsis', 'panel', 'panel-heading', 'panel-block', 'panel-icon', 'panel-tabs', 'tabs', 'container', 'hero', 'hero-body', 'input']);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__example_grid_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__example_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__example_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__example_box_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__example_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__example_box_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__example_form_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__example_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__example_form_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__example_grid_vue___default.a,
    Box: __WEBPACK_IMPORTED_MODULE_1__example_box_vue___default.a,
    FormComponent: __WEBPACK_IMPORTED_MODULE_2__example_form_vue___default.a
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugin_plugin__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    box: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__plugin_plugin__["b" /* bulmaComponentGenerator */])('box')
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    login: function login() {
      console.log('login in');
    },
    greet: function greet() {
      console.log('hey');
    },
    toggle: function toggle() {
      this.flag = !this.flag;
    }
  },
  data: function data() {
    return {
      flag: true
    };
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    greet: function greet() {
      console.log('hello');
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(11)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(17),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(10)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(15),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('columns', [_c('column', {
    attrs: {
      "is-10": "",
      "is-offset-1": ""
    }
  }, [_c('columns', [_c('column', [_c('notification', {
    attrs: {
      "is-info": ""
    },
    on: {
      "click": _vm.greet
    }
  }, [_vm._v("First column")])], 1), _vm._v(" "), _c('column', [_c('notification', {
    attrs: {
      "is-success": ""
    }
  }, [_vm._v("Second column")])], 1), _vm._v(" "), _c('column', [_c('notification', {
    attrs: {
      "is-warning": ""
    }
  }, [_vm._v("Third column")])], 1), _vm._v(" "), _c('column', [_c('notification', {
    attrs: {
      "is-danger": ""
    }
  }, [_vm._v("Fourth column")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('columns', [_c('column', {
    attrs: {
      "is-4": "",
      "is-offset-4": ""
    }
  }, [_c('field', {
    attrs: {
      "outerElement": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('control', {
    attrs: {
      "has-icons": "",
      "has-icons-left": "",
      "has-icons-right": "",
      "outerElement": "p"
    }
  }, [_c('b-input', {
    attrs: {
      "is-success": _vm.flag,
      "is-danger": !_vm.flag,
      "type": "text",
      "placeholder": "Text input",
      "value": "bulma"
    },
    on: {
      "input": _vm.toggle
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "outerElement": "span",
      "is-small": "",
      "is-left": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), (_vm.flag) ? _c('icon', {
    attrs: {
      "outerElement": "span",
      "is-small": "",
      "is-right": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e()], 1), _vm._v(" "), _c('help', {
    attrs: {
      "is-success": ""
    }
  }, [_vm._v("This username is available")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "is-primary": ""
    },
    on: {
      "click": _vm.greet
    }
  }, [_vm._v("Go")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('columns', [_c('column', {
    attrs: {
      "is-4": "",
      "is-offset-4": ""
    }
  }, [_c('box', [_c('media', [_c('media-left', [_c('b-image', {
    attrs: {
      "is-64x64": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/128x128.png",
      "alt": "Image"
    }
  })])], 1), _vm._v(" "), _c('media-content', [_c('content', [_c('p', [_c('strong', [_vm._v("John Smith")]), _vm._v(" "), _c('small', [_vm._v("@johnsmith")]), _vm._v(" "), _c('small', [_vm._v("31m")]), _vm._v(" "), _c('br'), _vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean efficitur sit amet massa fringilla egestas. Nullam condimentum luctus turpis.\n            ")])]), _vm._v(" "), _c('level', {
    attrs: {
      "is-mobile": ""
    }
  }, [_c('level-left', [_c('level-item', {
    attrs: {
      "outerElement": "a"
    }
  }, [_c('icon', {
    attrs: {
      "is-small": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })])], 1), _vm._v(" "), _c('level-item', {
    attrs: {
      "outerElement": "a"
    }
  }, [_c('icon', {
    attrs: {
      "is-small": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-retweet"
  })])], 1), _vm._v(" "), _c('level-item', {
    attrs: {
      "outerElement": "a"
    }
  }, [_c('icon', {
    attrs: {
      "is-small": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('hr'), _vm._v(" "), _c('Grid'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('Box'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('FormComponent')], 1)
},staticRenderFns: []}

/***/ })
],[4]);


// WEBPACK FOOTER //
// static/js/app.js